import './LandingPage.scss';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { PortContext } from '../service/MessageChannelContext';
import { Card } from '../components/micro/Card/Card';
import { Button } from '../components/micro/Button/Button';
import AnalysisButtonIcon from '../images/analysis-button-icon.png';
import { List } from '../components/micro/List/List';
import Step1 from '../images/step1.png';
import Step2 from '../images/step2.png';
import Step3 from '../images/step3.png';
import Acne from '../images/acne.png';
import Texture from '../images/texture.png';
import PoreSize from '../images/pores.png';
import DarkSpots from '../images/spots.png';
import Brightness from '../images/brightness.png';
import { ImageCarousel } from '../components/micro/ImageCarousel/ImageCarousel';
const CONTENT = {
  title: {
    en: 'SkinTech Analyzer',
    id: 'SkinTech Analyzer',
  },
  subtitle: {
    en: 'Your Virtual Skin Consultant!',
    id: 'Your Virtual Skin Consultant!',
  },
  skinNeedTitle: {
    en: 'Get to know your Skintuation',
    id: 'Get to know your Skintuation',
  },
  skinNeedContent: {
    en: 'Say goodbye to acne, dullness, and spots! Analyze your skin and get tailored product recommendations made just for you.',
    id: 'Ucapkan selamat tinggal pada jerawat, kulit kusam, dan flek! Dapatkan analisis kulit dan rekomendasi produk yang dipersonalisasi khusus untukmu.',
  },
  canGetTitle: {
    en: 'What can you get from here?',
    id: 'Apa yang bisa aku ketahui dari SkinTech Analyzer?',
  },
  canGetContent: {
    en: 'Unleash your skin\'s radiant glow and dive into your unique "Skintuation" with the Emina SkinTech Analyzer. Discover your true skin condition, embrace your natural beauty, and boost your skin confidence with us!',
    id: 'Temukan keceriaan kulitmu dan jelajahi "Skintuation" unikmu dengan Emina SkinTech Analyzer! Dapatkan pengetahuan lebih dalam tentang kulitmu, persembahan yang sempurna untuk meningkatkan kecantikan alami dan menaikkan kepercayaan dirimu bersama kami!',
  },
  howItWorks: {
    en: 'How it works',
    id: 'Gimana Caranya',
  },
  step1: {
    en: 'Step 1',
    id: 'Langkah 1',
  },
  step2: {
    en: 'Step 2',
    id: 'Langkah 2',
  },
  step3: {
    en: 'Step 3',
    id: 'Langkah 3',
  },
  step1Content: {
    en: 'Take your Selfie',
    id: 'Ambil Selfie-mu',
  },
  step2Content: {
    en: 'See skin analysis report',
    id: 'Lihat Laporan Skin Analysis',
  },
  step3Content: {
    en: 'See product recommendation',
    id: 'Lihat Rekomendasi Produk',
  },
  acne: { en: 'Acne', id: 'Jerawat' },
  texture: { en: 'Texture', id: 'Tekstur' },
  poreSize: { en: 'Pore size', id: 'Ukuran Pori' },
  darkSpots: { en: 'Dark Spots', id: 'Dark Spots' },
  brightness: { en: 'Brightness', id: 'Kulit Kemerahan' },
  analysisButton: {
    en: 'Analyze My Skin Now!',
    id: 'Analisa Kulitku Sekarang!',
  },
};

export const LandingPage = () => {
  const navigate = useNavigate();
  const { lang } = useContext(PortContext);
  return (
    <div className="landing-page">
      <div className="title">
        SKINTECH
        <br />
        <span>ANALYZER</span>
      </div>
      <div className="subtitle">{CONTENT.subtitle[lang]}</div>
      <Card title={CONTENT.skinNeedTitle[lang]} alignTitleLeft>
        <p>{CONTENT.skinNeedContent[lang]}</p>
      </Card>
      <Card title={CONTENT.howItWorks[lang]} alignTitleLeft>
        <List
          isFlex
          items={[
            {
              image: Step1,
              title: CONTENT.step1[lang],
              description: CONTENT.step1Content[lang],
            },
            {
              image: Step2,
              title: CONTENT.step2[lang],
              description: CONTENT.step2Content[lang],
            },
            {
              image: Step3,
              title: CONTENT.step3[lang],
              description: CONTENT.step3Content[lang],
            },
          ]}
        />
      </Card>
      <Card title={CONTENT.canGetTitle[lang]} alignTitleLeft>
        <ImageCarousel
          items={[
            {
              image: Acne,
              title: CONTENT.acne[lang],
            },
            {
              image: Texture,
              title: CONTENT.texture[lang],
            },
            {
              image: PoreSize,
              title: CONTENT.poreSize[lang],
            },
            {
              image: DarkSpots,
              title: CONTENT.darkSpots[lang],
            },
            {
              image: Brightness,
              title: CONTENT.brightness[lang],
            },
          ]}
        />
        <p>{CONTENT.canGetContent[lang]}</p>
      </Card>
      <Button text={CONTENT.analysisButton[lang]} icon={AnalysisButtonIcon} onClick={() => navigate('/howTo')} iconPosition="suffix" />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};
